import React from 'react'
import PropTypes from 'prop-types'
// import Helmet from 'react-helmet'
import { Helmet } from 'react-helmet-async'

const StaticMetaTags = ({ title, description, image, url, keywords }) => (
  <Helmet>
    <meta httpEquiv="Content-Language" content="en" charSet="utf-8" />
    <title>{title}</title>
    <meta
      name="description"
      content={description}
    />
    {
      keywords && <meta name="keywords" content={keywords} />
    }
    {
      url && <link rel="canonical" href={url.replace(/\/$/, '')} />
    }

    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image} />
    <meta property="og:url" content={url} />

    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />
    <meta name="twitter:card" content="summary_large_image" />
  </Helmet>
)

StaticMetaTags.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  keywords: PropTypes.string,
}

export default StaticMetaTags
